import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { MotivationFullDetails } from '../all-motivations/model/all-motivations.interface';
import { CultureDetails, Insight, InsightAggregationData, Insights, MotivationFullDetails, ScoreDetails, UserMotivationDetails } from '../../../all-motivations/model/all-motivations.interface';
import { APIS } from 'src/app/apis';
import { AbstractMotivationsService } from './motivations.abstract.service';
import { AbstractLocalStorageService } from '../localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from '../localStorage/local-storage.enum';
import { AbstractPersonalUserDataService } from '../personal-user-data/personal-user-data.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class MotivationsService implements AbstractMotivationsService {

  allMotivationsUrl =`${APIS.motivation}/allMotivations`;
  motivationDetailsUrl = `${APIS.motivation}/motivation`;
  motivationsForUserUrl = `${APIS.motivation}/motivationsForUser`;
  scoreForCounterpartUrl = `${APIS.motivation}/scoreForUser`;
  buklkScoresForCounterpartsUrl = `${APIS.motivation}/bulkScoresForUsers`;
  insightsForCounterpartUrl = `${APIS.motivation}/insightsForCounterpart`;
  insightsForSelfUrl = `${APIS.motivation}/insightsForSelf`;
  cultuerDetailsUrl = `${APIS.motivation}/culture`;

  motivationsMetaData: Map<string, MotivationFullDetails>;
  constructor(private http: HttpClient, 
              public localStorageService: AbstractLocalStorageService,
              private personalUserServer: AbstractPersonalUserDataService) {
    this.initMotivationsMetadataMap();
  }

  getAllMotivations(): Observable<MotivationFullDetails[]> {
    const result = this.http.get<MotivationFullDetails[]>(`${this.allMotivationsUrl}`);
    return result; 
  }

  getMotivation(id:string): Observable<MotivationFullDetails> {
      // return the requested motivation
      // console.log('trying to fetch motivation')
      
      return this.http.get<MotivationFullDetails>(`${this.motivationDetailsUrl}?motivationId=${id}`);
  }

  getMotivationsForUser(userId:string): Observable<UserMotivationDetails[]> {
    return this.http.get<UserMotivationDetails[]>(`${this.motivationsForUserUrl}?userId=${userId}`);
  }

  getScoreForUser(counterpartId:string): Observable<ScoreDetails> {
    return this.http.get<ScoreDetails>(`${this.scoreForCounterpartUrl}?counterpartId=${counterpartId}`);
  }

  getBulkScoresForUsers(counterpartIds:string): Observable<ScoreDetails[]> {
    return this.http.get<ScoreDetails[]>(`${this.buklkScoresForCounterpartsUrl}?counterpartIds=${counterpartIds}`);
  }

  getInsightsForTeamMember(): Observable<Insights>{
        throw new Error('Method not implemented.');
  }

  insightsForCounterpart (counterpartId: string): Observable<InsightAggregationData[]>{
    let result = this.http.get<InsightAggregationData[]>(`${this.insightsForCounterpartUrl}?counterpartId=${counterpartId}`);            

    return result;
  }

  insightsForSelf (): Observable<InsightAggregationData[]>{
    let result = this.http.get<InsightAggregationData[]>(`${this.insightsForSelfUrl}`);            

    return result;
  }

  reloadMotivationsMetaData(){
    // console.log ("reloadMotivationsMetaData is called");
    this.localStorageService.clear(LocalStorageKeys.partialMotivationsData);
    this.initMotivationsMetadataMap();
  }

  initMotivationsMetadataMap(){
    if (!this.personalUserServer.isUserLoggedIn()){
      return;
    }
    // const injector = AppInjector.getInjector();
    // let localStorageService = injector.get(LocalStorageService); 

    let motivationsData = undefined;

    try {
      motivationsData = this.localStorageService.get<MotivationFullDetails[]>(LocalStorageKeys.partialMotivationsData);
      } catch (ex) {
        // console.log(`in motivations.service, all motivations were not found in local storage, motivationsData is ${motivationsData}`);
        // do nothing, motivationData will remain undefined
    }

    // console.log(`in initmotivations service after try to get local storage motivations data is ${motivationsData}`);

    if (motivationsData != undefined){
      this.motivationsMetaData = new Map<string, MotivationFullDetails>();
      for (let motivation of motivationsData){
        this.motivationsMetaData.set(motivation.id, motivation);
      }
    }
    else{
      // console.log(`in motivations.service, get all motivations is called`);

      this.getAllMotivations().subscribe( motivations => {
        // console.log(`in motivations.service, all motivations are written to local storage`);
        this.localStorageService.write<MotivationFullDetails[]>(LocalStorageKeys.partialMotivationsData, motivations);

        this.motivationsMetaData = new Map<string, MotivationFullDetails>();
        for (let motivation of motivations){
          this.motivationsMetaData.set(motivation.id, motivation);
        }
      });
    }
  }

  verifyMetaDataMap(){
    if (this.motivationsMetaData == undefined || this.motivationsMetaData.values.length == 0){
      this.initMotivationsMetadataMap();
    }
  }


  getPartialMotivationDetails(motivationId:string):MotivationFullDetails{
    // console.log(`in MS getPartialMotivationDetails motivations timestamp is ${Date.now()} motivation id is ${motivationId}}`);

    this.verifyMetaDataMap();

    let foundMotivation: MotivationFullDetails  =  this.motivationsMetaData.get(motivationId)!;

    return foundMotivation;
  } 

  getMotivationColor(motivationId: string): string{
    let foundMotivation: MotivationFullDetails | undefined =  this.getPartialMotivationDetails(motivationId);
    
    if (foundMotivation == undefined){
      return "D98880";
    }

    return foundMotivation.color;    
  }

  public getMotivationIconName(motivationId: string): string {
    let motivation = this.getPartialMotivationDetails(motivationId);
    if (motivation) {
      return motivation.imageUrl;
    } else {
      return "play_arrow";
    }
  }

  public getMotivationName(motivationId: string): string {
    let motivation = this.getPartialMotivationDetails(motivationId);
    if (motivation) {
      return motivation.name;
    } else {
      return "";
    }
  }

  getCulture(id:string): Observable<CultureDetails> {
    // return the requested motivation
    // console.log('trying to fetch motivation')
    
    return this.http.get<CultureDetails>(`${this.cultuerDetailsUrl}?cultureId=${id}`);
}
}
